import { render, staticRenderFns } from "./SqliMatch.vue?vue&type=template&id=ad951442"
import script from "./SqliMatch.vue?vue&type=script&lang=js"
export * from "./SqliMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports